<!-- 裁判查询 -->
<template>
    <div>  
        <el-row class="mg-tb-20">
            <el-button type="primary" icon="el-icon-plus" @click="addDialog">新增裁判</el-button>
        </el-row>
        <el-table border :data="tableData" style="width: 100%;">
            <el-table-column  prop="username"  label="裁判名称"  width="180"/>
            <el-table-column  prop="userId"    label="裁判账号"/>
            <el-table-column  prop="sponsorPosition"    label="裁判职务"/>
            <el-table-column  fixed="right" label="操作"  width="180">
                <template slot-scope="scope" >
                    <el-button @click="updateDialog(scope.row)" type="text" size="medium">修改</el-button>
                    <el-button v-if="show" @click="setDeskDialog(scope.row)" type="text" size="medium">设置桌号</el-button>
                    <el-button  @click="deleteDialog(scope.row)" type="text" size="medium">删除</el-button>
                </template>                   
            </el-table-column>
        </el-table>
    <!-- 新增修改对话框 -->
    <el-dialog :title="titleSponsor" :visible.sync="open" width="600px" append-to-body>
        <el-form ref="form" :model="form" :rules="rules" label-width="100px">      
            <el-form-item label="裁判名称" prop="username">
                <el-autocomplete style="width: 100%;" :clearable="true"
                    v-model="form.username"
                    :fetch-suggestions="querySearch"
                    placeholder=""
                    :trigger-on-focus="false"
                    @select="handleSelect"
                ></el-autocomplete>
                <!-- <el-input v-model="form.username" placeholder="请输入裁判名称" :clearable="true"
                    @input="getUserInfoSearch"/> -->
            </el-form-item>       
            <!-- <el-form-item label="裁判账号" prop="userId">               
                <el-select v-model="form.userId" style="width:100%">
                    <el-option 
                        v-for="item in userInfoOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                </el-select>
            </el-form-item>     -->
            <el-form-item label="裁判职务" prop="sponsorPosition">
                <el-select v-model="form.sponsorPosition" style="width:100%" @change="selectPosition">
                    <el-option 
                        v-for="item in refereeOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                </el-select>
            </el-form-item>           
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitForm">确 定</el-button>
            <el-button @click="cancel">取 消</el-button>
        </div>
    </el-dialog>
    <el-dialog title="设置裁判桌号" :visible.sync="openDesk" width="600px" append-to-body>
        <el-form ref="deskForm" :model="deskForm" :rules="rules" label-width="100px">      
            <el-form-item label="桌号" prop="checkDeskNo">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" 
                @change="handleCheckAllChange">全选</el-checkbox>
                <el-checkbox-group v-model="deskForm.checkDeskNo" >
                    <el-checkbox  @change="handleCheckedCitiesChange"
                        v-for="item in listOption"
                        :key="item"
                        :label="item"
                        >{{ item}}
                        </el-checkbox>
                </el-checkbox-group>
            </el-form-item>    
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="submitDesk">确 定</el-button>
            <el-button @click="cancelForm">取 消</el-button>
        </div>
    </el-dialog>
    <el-dialog :visible.sync="visible">
        <div>该桌已有裁判，是否继续变更裁判?</div>
        <template v-slot:footer>
        <el-button @click="nextDialog">确认</el-button>
         <el-button @click="visible=false">取 消</el-button>
        </template>
    </el-dialog>
</div>
</template>

<script>
export default {
    props: {
        publishId: {
            type: String,
            default: ''
        },
        show: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            checkAll: false,
            form: {
                index: '',
            },
            deskForm:{
                deskNo: null,
                checkDeskNo: [],
            },           
            openDesk:false,
            queryParams: {
                page: 1,
                pagesize: 10
            },
            tableData: [],  
            amount: 0,  
            total: 0,
            titleSponsor: '',
            open: false,
            disabled: false,
            isIndeterminate: true,
            rules:{
                username: [
                    { required: true, message: "请输入裁判名称", trigger: "blur" }
                ],
                usernId: [
                    { required: false, message: "请输入裁判账号", trigger: "blur" }
                ],
                sponsorPosition: [
                    { required: false, message: "请选择裁判职务", trigger: "change" }
                ],
                checkDeskNo:[
                    { required: true, message: "请选择桌号", trigger: "change" }
                ],
            },
            refereeOption: [],
            userInfoOption: [],
            refereeInfo: {},
            listOption: [],
            visible:false
        }   
    },
    created() {
        this.initData()
        this.getRefereeRole()        
    },
    mounted() {
       
    },
    computed:{
        title(){
            return this.$route.meta.title
        }    
    },
    methods: {
        initData(){
            let params = {
                opcode:this.$code.RefereeQuery,
                i_serial_mark: this.publishId
            };
            this.$api.requestAPI(params).then(res =>{
                if(res.IsSuccess){                 
                    if(res.Data.SumCount > 0){                        
                        let result = res.Data.DataTable;
                        this.tableData = result.map(item =>{
                            return{
                                index: item['序号'],
                                userId: item['裁判账号'],
                                username: item['裁判'],
                                serialMark: item['赛事标识'],
                                sponsorPosition: item['职务'],
                                level: item['等级'],
                            }
                        })
                        // console.log('裁判', this.tableData)
                        let levelArr = this.tableData.map(i=>i.level)
                        let maxLevel = Math.max(...levelArr); 
                        // console.log('裁判', maxLevel)
                        this.$emit('maxLevel',maxLevel)
                    }else{
                        this.tableData = []
                        this.$emit('maxLevel',0)
                    }
                }
            }).catch(error =>{
                console.log(error);
            })
        },
        // 裁判桌号查询
        getDeskNumber(){
            let params = {
                opcode: this.$code.PubDeskQuery,
                i_serial_mark: this.publishId,
                i_desk_no: '',
                v_referee: '',
                v_referee_no: ''
            }
            this.$api.requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    if(result.length > 0){
                        this.listOption = Array.from({ length: result.length }, (_, index) => index + 1)
                    }else{
                        this.$message.error('请先设置！')
                    }                   
                }
            })      
        },  
        // 查询裁判职务 
        getRefereeRole(){
            let params = {
                opcode: this.$code.SystemCode,
                v_parent_name: '',
                i_no: 16,
            }
            this.$api._requestAPI(params).then(res =>{
                if (res.IsSuccess) {
                    let result = res.Data.DataTable
                    this.refereeOption = result.map(item=>{
                        return{
                            value: item['词条索引'],
                            label: item['中文描述']
                        }
                    })
                }
            })
        },
        async querySearch(queryString, cb){
            let result = queryString ? await this.getUserInfoSearch(queryString) : []  
            cb(result)
        },
        // 模糊搜索查询
        getUserInfoSearch(val){
            return new Promise((resolve,reject)=>{
                if(val.length > 1){
                    let params = {
                        opcode: this.$code.UserInfoSearch,
                        v_name: val,
                        v_caption: '',
                        v_phone: '',
                    }
                    // 查询信息
                    this.$api._requestAPI(params).then(res => {
                        if (res.IsSuccess) {
                            let result = res.Data.DataTable
                            if(result.length === 0){
                                this.form.userId = ''
                                this.userInfoOption = []
                            }else{
                                let arr  = result.map(item=>{
                                    return{
                                        value:item['姓名'] +''+ item['手机号'],
                                        userId: item['会员账号'],
                                        username: item['姓名'],
                                        phone: item['手机号'],
                                        role: item['角色'],
                                        level: item['星级']
                                }
                            })                            
                            this.userInfoOption = arr.filter(i=>i.role === '裁判')
                            resolve(this.userInfoOption)                         
                        }
                    }
                    }).catch(err => { reject(err)})
                }else{
                    this.form.userId = ''
                }
            })         
        },
        handleSelect(row){
            this.form.username = row.username
            this.form.userId = row.userId
            this.form.sponsorPosition = '1'
        },
        // 模糊搜索查询 这个方法暂时不用
        getUserInfoSearchTest(val){            
            if(val.length > 1){
                let params = {
                    opcode: this.$code.UserInfoSearch,
                    v_name: this.form.username,
                    v_caption: '',
                    v_phone: '',
                }
                // 查询账户信息
                this.$api._requestAPI(params).then(res => {
                    if (res.IsSuccess) {
                        let result = res.Data.DataTable
                        if(result.length === 0){
                            this.form.sponsorPosition = ''
                            this.form.userId = ''
                            this.userInfoOption = []
                        }else{
                            let list = result.map(item=>{
                                return{
                                    value:item['会员账号'],
                                    label: item['会员账号'],
                                    username: item['姓名'],
                                    phone: item['手机号'],
                                    role: item['角色'],
                                    level: item['星级']
                                }
                            })  
                            this.userInfoOption = list.filter(i=>i.role==='裁判')
                            // if(this.userInfoOption.length > 0){
                            //     this.form.userId = this.userInfoOption[0].value  
                            //     this.form.username = this.userInfoOption[0].username
                            //     this.form.sponsorPosition = '1'
                            // }else{
                            //     this.form.userId = ''  
                            //     this.form.sponsorPosition = ''
                            // }                            
                        }
                    }
                }).catch(err => {
                    // this.$message.error("登录失败，请重新登录")
                })
            }else{
                this.form.userId = ''
            }           
        },
        addDialog(){
            this.getRefereeRole()
            this.form = {
                username: '',
                userId: '',
                sponsorPosition: '',
            }
            this.titleSponsor = '新增裁判'
            this.open = true
            this.flag = 1
        },
        updateDialog(row){
            this.open = true
            this.titleSponsor = '修改裁判'
            this.flag = 2
            this.form = {...row}
        },
        deleteDialog(row){
            this.flag = 3
            this.form = {...row}
            this.$confirm(`确认删除 ${row.username} 裁判吗？`).then(res=>{
                this.submitForm()
            }).catch(err=>{
                console.log("取消")
            })
        },
        submitForm(){
            let params = {
                opcode:this.$code.RefereeAddOrUpdate,
                i_serial_mark: this.publishId,
                i_serial: this.form.index,
                v_referee_name: this.form.username,
                v_referee_no: this.form.userId,
                v_referee_post: this.form.sponsorPosition,
                i_flag: this.flag
            };
            this.$api.requestAPI(params).then( res =>{
                if(res.IsSuccess){
                    this.$message.success(res.Message);  
                    this.initData()   
                    this.open = false          
                }else{
                    this.$message.error(res.Message);
                }  
            }).catch( error =>{
                console.log(error);
            })  
        },
        cancel(){
            this.open = false                      
            this.resetForm('form')
        },
        cancelForm(){
            this.openDesk = false  
            this.resetForm('deskForm')
        },
        searchQuery() {
            this.initData()
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        setDeskDialog(row){
            this.openDesk = true
            this.refereeInfo =  row
            this.getDeskNumber()
        },
        submitDesk(){     
            if(this.deskForm.checkDeskNo.length > 0){    
                if(this.listOption.length > 0){
                    this.visible = true
                }else{
                    this.$emit('message',this.refereeInfo,this.deskForm.checkDeskNo)                
                    this.openDesk = false
                }   
            }else{
                this.$message.error('请选择桌号！')            
            }             
        },
        nextDialog(){
            this.$emit('message',this.refereeInfo,this.deskForm.checkDeskNo)                
            this.openDesk = false
            this.visible = false
        },
        handleCheckAllChange(val){
            this.deskForm.checkDeskNo = val ? this.listOption : [];
            // console.log(this.deskForm.checkDeskNo)
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value){
            let checkedCount = this.deskForm.checkDeskNo.length;
            this.checkAll = checkedCount === this.listOption.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.listOption.length;
        },
        selectPosition(value){
            // console.log(value)
        }
    }
}
</script>
<style lang='scss' scoped>
@import '@/assets/css/style.scss';
</style>


// WEBPACK FOOTER //
// src/views/publish/components/refereeQuery.vue